import { render } from "./LRYQ.vue?vue&type=template&id=350f1fda&scoped=true"
import script from "./LRYQ.vue?vue&type=script&lang=js"
export * from "./LRYQ.vue?vue&type=script&lang=js"

import "./LRYQ.vue?vue&type=style&index=0&id=350f1fda&scoped=scoped&lang=css"

import exportComponent from "D:\\wcb\\www\\wifigolf\\s_api\\public\\ClpgaApp121\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-350f1fda"]])

export default __exports__